// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item[data-v-6f0b9e18] {\n  border-bottom: 1px solid var(--border-color);\n  padding: 0.5em;\n}\n.item[data-v-6f0b9e18]:hover {\n  background-color: var(--background-hover-color);\n}", ""]);
// Exports
module.exports = exports;
